import { QueryClient, queryOptions, useQuery } from "@tanstack/react-query";
import type { InferResponseType } from "hono/client";
import { apiPost, readJson, rpc } from "./api";

/** Shape of `GET /api/me` (src/worker/app.ts). */
export type Me = InferResponseType<typeof rpc.api.me.$get>;

/** Shape of `GET /api/config` (public). */
export type AppConfig = InferResponseType<typeof rpc.api.config.$get>;

export const queryClient = new QueryClient({
  defaultOptions: { queries: { retry: false, staleTime: 60_000, refetchOnWindowFocus: false } },
});

export const meQuery = queryOptions({ queryKey: ["me"], queryFn: () => readJson(rpc.api.me.$get()) });

export const configQuery = queryOptions({
  queryKey: ["config"],
  queryFn: () => readJson(rpc.api.config.$get()),
  staleTime: Infinity,
});

/** Use inside authenticated routes only (the layout's beforeLoad guarantees data). */
export function useMe(): Me {
  const { data } = useQuery({ ...meQuery, enabled: false });
  if (!data) throw new Error("useMe() called outside an authenticated route");
  return data;
}

export async function signOut(): Promise<void> {
  await apiPost("/api/auth/sign-out", {}).catch(() => undefined);
  queryClient.removeQueries({ queryKey: meQuery.queryKey });
}
